import React, { useState, useEffect } from 'react';

const NoRerender = ({ html }) => {
  const [serverSide, setServerSide] = useState(true);

  useEffect(() => {
    setServerSide(false);
  }, []);

  return serverSide
    ? null
    : <div className="oxp" dangerouslySetInnerHTML={{ __html: html }} />;
};

export default NoRerender;
